import React, { useState, useEffect } from "react";
import {
  DonationButtonsMobile,
  DonationButtonsNotMobile,
} from "src/components/Button";
import classNames from "classnames";

export const Homepage = () => {
  const [isMonthly, setIsMonthly] = useState(true);
  const [donationAmt, setDonationAmt] = useState(10);
  const [customAmt, setCustom] = useState("");
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setViewportWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let donationFormText =
    viewportWidth < 400
      ? "Your support today will help keep our reporters on the beat and our journalism always free to read."
      : "Local problems don’t get solved without local journalism. We cover New York's uncovered neighborhoods, hold the powerful to account, and make sense of the greatest city in the world. Your support today will help keep our reporters on the beat and our journalism always free to read.";

  const donationAmts = [5, 10, 15, 20];

  const generateDonationURL = () => {
    if (customAmt) {
      return `https://donorbox.org/donatenyc/?amount=${customAmt}&default_interval=${
        isMonthly ? "m" : "o"
      }`;
    }
    return `https://donorbox.org/donatenyc/?amount=${
      isMonthly ? donationAmt : donationAmt * 12
    }&default_interval=${isMonthly ? "m" : "o"}`;
  };

  const styles = {
    fontFamily: "Sharp Grotesk",
    fontSize: "14px",
  };

  const customAmtStyles = {
    marginRight: "45px",
    marginLeft: "45px",
  };

  const continueButton = {
    marginTop: "20px",
  };

  return (
    <div
      style={styles}
      className="is-flex is-flex-direction-column has-text-centered is-align-content-center pb-6"
    >
      {/*  is-size-2 too big for mobile*/}
      <h1 className="has-text-info title pt-6 is-size-2">
        {viewportWidth < 400 ? (
          <>
            Your Donation <br />
            Is Essential.
          </>
        ) : (
          "Your Donation Is Essential."
        )}
      </h1>
      <h2 className="mt-0 pt-0 mx-6 mb-1 has-text-white">{donationFormText}</h2>

      <div className="control pb-3 mt-2 has-text-white">
        <label className="radio">
          <input
            className="mr-1"
            type="radio"
            name="answer"
            checked={isMonthly}
            onChange={() => {
              setIsMonthly(true);
            }}
          />
          Monthly Donation
        </label>
        <label className="radio">
          <input
            className="mr-1"
            type="radio"
            name="answer"
            checked={!isMonthly}
            onChange={() => {
              setIsMonthly(false);
            }}
          />
          One-Time Donation
        </label>
      </div>

      {viewportWidth < 400 ? (
        <DonationButtonsMobile
          donationAmts={donationAmts}
          donationAmt={donationAmt}
          setDonationAmt={setDonationAmt}
          isMonthly={isMonthly}
        />
      ) : (
        <DonationButtonsNotMobile
          donationAmts={donationAmts}
          donationAmt={donationAmt}
          setDonationAmt={setDonationAmt}
          isMonthly={isMonthly}
        />
      )}

      <div
        className={classNames(
          "is-align-content-center is-justify-content-center mt-4",
          viewportWidth < 400 ? "" : "field is-grouped"
        )}
      >
        <p
          className="control"
          style={viewportWidth < 400 ? customAmtStyles : {}}
        >
          <input
            className="input is-info"
            type="number"
            placeholder="$ Custom Amount"
            value={customAmt}
            onChange={(e) => {
              setCustom(e.target.value);
            }}
            onClick={() => {
              setDonationAmt(0);
            }}
          ></input>
        </p>
        <p
          className="control has-text-weight-bold"
          style={viewportWidth < 400 ? continueButton : {}}
        >
          <a
            href={generateDonationURL()}
            target="_blank"
            rel="noopener noreferrer"
            className="button is-rounded is-info is-outlined has-background-white"
          >
            continue
          </a>
        </p>
      </div>
    </div>
  );
};
